import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RecoilRoot } from 'recoil';
import { HelmetProvider } from 'react-helmet-async';

const app = (
    <RecoilRoot>
        <HelmetProvider>
            <App />
        </HelmetProvider>
    </RecoilRoot>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(app);
